import holdingsHistoryReducer, { defaultState } from "./holdingsHistoryReducer";

export { defaultState };
export default holdingsHistoryReducer;
